import React from 'react';
type BadgeVariant = 'teal' | 'amber' | 'red' | 'slate' | 'outline';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}
export function Badge({
  children,
  variant = 'slate',
  className = ''
}: BadgeProps) {
  const variants = {
    teal: 'bg-teal-500/10 text-teal-400 border border-teal-500/20',
    amber: 'bg-amber-500/10 text-amber-400 border border-amber-500/20',
    red: 'bg-red-500/10 text-red-400 border border-red-500/20',
    slate: 'bg-slate-700/50 text-slate-300 border border-slate-600',
    outline: 'bg-transparent text-slate-400 border border-slate-700'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variants[variant]} ${className}`} data-id="element-159">
      {children}
    </span>;
}